export const ACHIEVEMENT_RECORDS = '/achievement_records/'
export const ACHIEVEMENT_RECORDS_ALL = `${ACHIEVEMENT_RECORDS}all`
export const ACHIEVEMENT_RECORDS_TYPES = `${ACHIEVEMENT_RECORDS}types`
export const ACHIEVEMENT_RECORDS_CHANGE_STATUS = `${ACHIEVEMENT_RECORDS}change/status`
export const ACHIEVEMENT_RECORDS_STUDENT = `${ACHIEVEMENT_RECORDS}student/`
